import {Sound} from '../Sound'
import {UIChatPostController} from './UIChatPostController'
import {ChatData} from '@colonist/shared-types'

export class UIChatPost {
    static post(container: HTMLDivElement, chatData: ChatData, preventScroll: boolean = false, makeSound: boolean = true): HTMLElement {
        const postController = new UIChatPostController(container, chatData)
        if(makeSound) Sound.playSound(Sound.SoundType.MessageNotification)
        if(!preventScroll) container.scrollTop = container.scrollHeight
        return postController.post
    }
}
